import { OhsUser } from '../../user/OhsUser';
import { ModuleHomeUrl } from '../leftSideDrawer/OhsLeftSideDrawerModuleList';
import { OhsBreadcrumbsNameAndRef } from './OhsBreadcrumbsServices';

export const OhsBreadCrumbCorporateRisk = (
  ohsBreadcrumbsNameAndRef: OhsBreadcrumbsNameAndRef,
  modulePath: string,
  subPath: string,
  viewPath: string,
  operationPath: string,
  user: OhsUser
) => {
  const defaultModuleRef = {
    href: (ModuleHomeUrl[user.tier.type] as any).corporateRisk,
    name: user.configs.corporateRisk?.TITLE ?? '',
  };

  if (subPath === 'home') {
    ohsBreadcrumbsNameAndRef.leafName = {
      name: defaultModuleRef?.name,
    };
  } else if (viewPath === 'view') {
    ohsBreadcrumbsNameAndRef.moduleRef = defaultModuleRef;
    ohsBreadcrumbsNameAndRef.leafName = { name: 'View' };
  } else if (operationPath.indexOf('edit') > -1) {
    ohsBreadcrumbsNameAndRef.moduleRef = defaultModuleRef;
    ohsBreadcrumbsNameAndRef.parentOperationRef = {
      href: `/${modulePath}/${subPath}/view`,
      name: 'View',
    };
    ohsBreadcrumbsNameAndRef.leafName = { name: 'Edit' };
  } else if (operationPath.indexOf('signoff') > -1) {
    ohsBreadcrumbsNameAndRef.moduleRef = defaultModuleRef;
    ohsBreadcrumbsNameAndRef.parentOperationRef = {
      href: `/${modulePath}/${subPath}/view`,
      name: 'View',
    };
    ohsBreadcrumbsNameAndRef.leafName = { name: 'Signoff' };
  } else if (operationPath.indexOf('completed') > -1) {
    ohsBreadcrumbsNameAndRef.moduleRef = defaultModuleRef;
    ohsBreadcrumbsNameAndRef.parentOperationRef = {
      href: `/${modulePath}/${subPath}/view?tab=history`,
      name: 'View',
    };
    ohsBreadcrumbsNameAndRef.leafName = { name: 'Evidence' };
  } else if (subPath === 'add') {
    ohsBreadcrumbsNameAndRef.moduleRef = defaultModuleRef;
    ohsBreadcrumbsNameAndRef.leafName = { name: 'Add' };
  }
  return ohsBreadcrumbsNameAndRef;
};
